import cx from 'classnames';
import PropTypes from 'prop-types';

import NotificationSuccess from 'src/assets/icons/NotificationSuccess';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

const propTypes = {
  className: PropTypes.string,
};

const defaultProps = {
  className: null,
};

export const SuccessMessage = ({ className }) => {
  const styles = useStyles();

  return (
    <div className={cx(styles.root, className)}>
      <NotificationSuccess className={styles.icon} />
      <CustomTypography
        className={styles.description}
        variant={TYPOGRAPHY_VARIANT.paragraph14}
      >
        This text complies with AP style guidelines.
      </CustomTypography>
    </div>
  );
};

SuccessMessage.propTypes = propTypes;
SuccessMessage.defaultProps = defaultProps;
